import { Renderer } from '@unseenco/taxi';
import Dotdotdot from "dotdotdot-js";
import "@splidejs/splide/css";
import { Splide } from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';
import { gHome, gAbout, gFAQ, gBlog } from './gradients.js'
import { moveNav } from './moveNav.js'
import 'bootstrap';

export class BlogRenderer extends Renderer {
  initialLoad() {
    // run code that should only happen once for your site
    this.wrapper.style.backgroundImage = gBlog;
    $(".blob").offset({top:moveNav('blog')});

    this.onEnter();
    this.onEnterCompleted();
  }

  onEnter() {
    // run after the new content has been added to the Taxi container


}

  onEnterCompleted() {
     // run after the transition.onEnter has fully completed
     var blogCarousel = new Splide( '#blog-carousel', {
      type   : 'loop',
      perPage: 1,
      width: '70vw',
      height: '70vh',
      focus  : 'center',
      grid: {
          rows: 2,
          cols: 3,
          gap : {
              row: '1rem',
              col: '1.5rem',
          },
      },
      breakpoints: {
          950: {
              grid: {
                  rows: 2,
                  cols: 2,
              },
          },
          600: {
              height: '60vh',
              grid: {
                  rows: 2,
                  cols: 1,
              },
          },
      },
    } ).mount( { Grid } );
  
      const blogDescList = document.querySelectorAll(".blog-desc");
  
      blogDescList.forEach((blogDesc) => {
      let wrapper = blogDesc;
      new Dotdotdot( wrapper );
      });
  
      
      $(".blogCall").on("click", function (e) {
          var blog_pk = $(this).attr("id");
  
          $.ajax({
              type: 'GET',
              url: "/blog/",
              data: {"blog_pk": blog_pk},
              success: function (response) {
                  // if not valid user, alert the user
                  var blogData = response[0];
          
                  var titleText = blogData.title;
                  
                  var dateText = blogData.date;
              
                  var bodyText = blogData.body;
              
                  $("#blogModalLabel").html(titleText);
                  $("#blogDate").html(dateText);
                  $("#blogBody").html(bodyText);

                  $('#blogModal').modal('toggle');

    
              },
              error: function (response) {
    
                  console.log(response);
              }
          });
  

          console.log('regular click')
  
  
  
      });
  

     $('#blogNav').addClass("navbar-font-active");
     $('#blogNav').parent().addClass("bg-light px-2 rounded-pill");
 
  }

  onLeave() {
    // run before the transition.onLeave method is called
    $('#blogNav').removeClass("navbar-font-active");
    $('#blogNav').parent().removeClass("bg-light px-2 rounded-pill");
  }

  onLeaveCompleted() {
    // run after the transition.onleave has fully completed
  }
};


export class CustomRenderer extends Renderer {
  initialLoad() {
    // run code that should only happen once for your site
    if (this.content.id == 'home') {
        this.wrapper.style.backgroundImage = gHome;
        $(".blob").offset({top:moveNav('home')});
        $('#homeNav').attr('fill', '#7C7373');
        $('#homeNav').parent().addClass("bg-light");
    }
    else if (this.content.id == 'about') {
        this.wrapper.style.backgroundImage = gAbout;
        $(".blob").offset({top:moveNav('about')});
        $('#aboutNav').addClass("navbar-font-active");
        $('#aboutNav').parent().addClass("bg-light px-2 rounded-pill");
    }
    else if (this.content.id == 'faq') {
        this.wrapper.style.backgroundImage = gFAQ;
        $(".blob").offset({top:moveNav('faqs')});
        $('#faqsNav').addClass("navbar-font-active");
        $('#faqsNav').parent().addClass("bg-light px-2 rounded-pill");
    }
    else if (this.content.id == 'blog') {
        this.wrapper.style.backgroundImage = gBlog;
        $(".blob").offset({top:moveNav('blog')});
        $('#blogNav').addClass("navbar-font-active");
        $('#blogNav').parent().addClass("bg-light px-2 rounded-pill");
    }

    this.onEnter();
    this.onEnterCompleted();
  }

  onEnter() {
  }

  onEnterCompleted() {
     // run after the transition.onEnter has fully completed
     if (this.content.id == 'home') {
      $('#homeNav').attr('fill', '#7C7373');
      $('#homeNav').parent().addClass("bg-light");
    }
    else if (this.content.id == 'about') {
      $('#aboutNav').addClass("navbar-font-active");
      $('#aboutNav').parent().addClass("bg-light px-2 rounded-pill");
    }
    else if (this.content.id == 'faq') {
      $('#faqsNav').addClass("navbar-font-active");
      $('#faqsNav').parent().addClass("bg-light px-2 rounded-pill");
    }
    else if (this.content.id == 'blog') {
      $('#blogNav').addClass("navbar-font-active");
      $('#blogNav').parent().addClass("bg-light px-2 rounded-pill");
    }
  }

  onLeave() {
    if (this.content.id == 'home') {
      $('#homeNav').attr('fill', 'rgba(248, 249, 250)');
      $('#homeNav').parent().removeClass("bg-light");
    }
    else if (this.content.id == 'about') {
      $('#aboutNav').removeClass("navbar-font-active");
      $('#aboutNav').parent().removeClass("bg-light px-2 rounded-pill");
    }
    else if (this.content.id == 'faq') {
      $('#faqsNav').removeClass("navbar-font-active");
      $('#faqsNav').parent().removeClass("bg-light px-2 rounded-pill");
    }
    else if (this.content.id == 'blog') {
      $('#blogNav').removeClass("navbar-font-active");
      $('#blogNav').parent().removeClass("bg-light px-2 rounded-pill");
    }

}

  onLeaveCompleted() {
    // run after the transition.onleave has fully completed
  }
}
